import { Stack, StackProps } from '@chakra-ui/react'
import { FC } from 'react'

export const LandingContainer: FC<StackProps> = (props) => {
  return <Stack w="full" maxW="calc(min(100vw, 1280px))" m="0 auto" px="24px" {...props} />
}
